module.exports = __webpack_public_path__ + "img/speechBubble.240cb5ba.png";